import { render, staticRenderFns } from "./Prematchstatscore.vue?vue&type=template&id=2c332c4a"
import script from "./Prematchstatscore.vue?vue&type=script&lang=js"
export * from "./Prematchstatscore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports